const translations = {
    es: {
        recoveryDescription:
            "Seleccionar el modelo de dispositivo a recuperar.",
        recoveryRange: "Seleccionar el rango de fechas para recuperar.",
        recoveryDay: "Dia de inicio de recuperación",
        needModel: "Seleccione un modelo de dispositivo.",
        needDateRange: "Seleccione un rango de fechas.",
        recoveryConfirm:
            "Se enviara una peticion de recuperación a los dispositivos seleccionados. Cuando finalize recibira una notificación con el resultado.",
        recoverySuccess: "Se ha enviado la solcitud correctamente.",
        recoveryError: "Error al enviar la solicitud.",
        // Filter labels
        "filters.downloadType": "Descarga",
        "filters.wasteType": "Fracción",
        "filters.groups": "Grupos",
        "filters.zones": "Zonas",
        "filters.routes": "Rutas",
        "filters.islands": "Islas",
        "filters.date": "Fecha",

        // Button texts
        "filters.clearFilters": "Limpiar filtros",
        "filters.search": "Buscar",
        "filters.downloadCSV": "CSV",
        "filters.downloadExcel": "Excel",
        "filters.downloadExcelTitle": "Descargar Excel",
        "filters.clearDates": "Limpiar fechas",

        // Select options
        "filters.all": "Todos",

        // Results text
        "filters.found": "Encontrados: ",
        "filters.noData": "Sin Datos",
        "filters.pages": "Págs",
        "filters.total": "Tot",

        // Input labels
        "filters.containerUID": "UID - Contenedor",
        "filters.deviceUUID": "UUID - Dispositivo",
        "filters.fillLevel": "Nivel Llenado min-max",

        // Input placeholders
        "filters.minimum": "minimo",
        "filters.maximum": "maximo",
    },
    en: {
        recoveryDescription: "Select the device model to be recove-red.",
        recoveryRange: "Select the date range to retrieve.",
        recoveryDay: "Start date of recovery",
        needModel: "Select a device model.",
        needDateRange: "Select a date range.",
        recoveryConfirm:
            "A recovery request will be sent to the selected devices. When finished you will receive a notification with the result.",
        recoverySuccess: "The request was sent successfully.",
        recoveryError: "Error sending the request.",
        // Filter labels
        "filters.downloadType": "Download Type",
        "filters.wasteType": "Waste Type",
        "filters.groups": "Groups",
        "filters.zones": "Zones",
        "filters.routes": "Routes",
        "filters.islands": "Islands",
        "filters.date": "Date",

        // Button texts
        "filters.clearFilters": "Clear filters",
        "filters.search": "Search",
        "filters.downloadCSV": "CSV",
        "filters.downloadExcel": "Excel",
        "filters.downloadExcelTitle": "Download Excel",
        "filters.clearDates": "Clear dates",

        // Select options
        "filters.all": "All",

        // Results text
        "filters.found": "Found: ",
        "filters.noData": "No Data",
        "filters.pages": "Pages",
        "filters.total": "Total",

        // Input labels
        "filters.containerUID": "Container UID",
        "filters.deviceUUID": "Device UUID",
        "filters.fillLevel": "Fill Level min-max",

        // Input placeholders
        "filters.minimum": "minimum",
        "filters.maximum": "maximum",
    },
};

export default translations;
